import "bootstrap/dist/css/bootstrap.min.css";
import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { Component } from "react";
import "./App.css";
import { history } from "./history";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateAvailable: false,
    };
  }

  componentDidMount = async () => {
    // Registra Service Worker apenas em produção/staging
    if (
      process.env.REACT_APP_NODE_ENV === "production" ||
      process.env.REACT_APP_NODE_ENV === "staging"
    ) {
      serviceWorkerRegistration.register({
        onUpdate: this.handleUpdate,
        onSuccess: this.handleSuccess,
      });
    }

    // Adiciona listener para mudanças de controller
    if ("serviceWorker" in navigator) {
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (!refreshing) {
          refreshing = true;
          console.log("Service Worker atualizado, recarregando...");
          window.location.reload();
        }
      });
    }

    // Verifica atualizações em mudanças de rota
    history.listen(() => {
      this.checkForUpdates();
    });
  };

  handleUpdate = (registration) => {
    console.log("Nova atualização disponível");

    if (registration.waiting) {
      // Mostra notificação para o usuário
      if (
        window.confirm(
          "Uma nova versão está disponível. Deseja atualizar agora?"
        )
      ) {
        this.triggerUpdate(registration);
      }
    }
  };

  handleSuccess = () => {
    console.log("Conteúdo está em cache para uso offline");
  };

  checkForUpdates = () => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration) {
          registration.update();
        }
      });
    }
  };

  triggerUpdate = (registration) => {
    // Limpa storages antes da atualização
    localStorage.clear();
    sessionStorage.clear();

    // Envia mensagem para o Service Worker pular a espera
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  };

  // Método para limpar cache manualmente (pode ser chamado de um botão)
  clearCacheManually = async () => {
    if (
      window.confirm("Isso irá limpar todo o cache do aplicativo. Continuar?")
    ) {
      try {
        await serviceWorkerRegistration.forceUpdate();
      } catch (error) {
        console.error("Erro ao limpar cache:", error);
        alert("Erro ao limpar cache. Tente recarregar a página manualmente.");
      }
    }
  };

  render() {
    return (
      <BrowserRouter>
        <Router />
        {/* Botão opcional para limpar cache manualmente */}
        {/* <button 
          onClick={this.clearCacheManually}
          style={{position: 'fixed', bottom: 10, right: 10, zIndex: 9999}}
          className="btn btn-warning btn-sm"
        >
          Limpar Cache
        </button> */}
      </BrowserRouter>
    );
  }
}
